export const typography = {
  fontSize: {
    '6xl': 60,
    '5xl': 40,
    '4xl': 36,
    '3xl': 32,
    '2xl': 24,
    xl: 24,
    lg: 24,
    base: 20,
    sm: 16,
    xs: 14,
  },
  lineHeight: {
    '6xl': 72,
    '5xl': 48,
    '4xl': 44,
    '3xl': 40,
    '2xl': 32,
    xl: 32,
    lg: 32,
    base: 30,
    sm: 24,
    xs: 20,
  },
};

export const getFontSizeWithLineHeight = (size: keyof typeof typography.fontSize) => {
  return [
    `${typography.fontSize[size]}px`,
    `${typography.lineHeight[size]}px`,
  ];
};
